import { render } from "./PatientBags.vue?vue&type=template&id=4b23ab2b"
import script from "./PatientBags.vue?vue&type=script&lang=js"
export * from "./PatientBags.vue?vue&type=script&lang=js"

import "./PatientBags.vue?vue&type=style&index=0&id=4b23ab2b&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__